module.exports = __webpack_public_path__ + "media/svg/cx-d1447c43.svg";